module.exports = __webpack_public_path__ + "img/icon-edit.90972fcd.svg";